import { Record, Union } from "../../../fable_modules/fable-library-js.4.19.0/Types.js";
import { record_type, bool_type, option_type, list_type, class_type, union_type, int32_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { Dta_DtaListItem_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { UploadResult_$reflection, Paginated$1_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Contracts.fs.js";
import { FSharpResult$2 } from "../../../fable_modules/fable-library-js.4.19.0/Result.js";
import { Remote$1_$reflection, GlobalMsg_$reflection } from "../../../../Bfs.Web.Portale/Types.fs.js";
import { isEmpty } from "../../../fable_modules/fable-library-js.4.19.0/List.js";

export class Page extends Union {
    constructor(page) {
        super();
        this.tag = 0;
        this.fields = [page];
    }
    cases() {
        return ["DtaList"];
    }
}

export function Page_$reflection() {
    return union_type("Dta.Types.Page", [], Page, () => [[["page", int32_type]]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["LoadPage", "PageLoaded", "UploadFiles", "FileUploaded", "DeleteUploadedFile", "UploadedFileDeleted", "ConfirmUploadedFiles", "UploadedFilesConfirmed", "GlobalMsg"];
    }
}

export function Msg_$reflection() {
    return union_type("Dta.Types.Msg", [], Msg, () => [[["page", int32_type]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [Paginated$1_$reflection(Dta_DtaListItem_$reflection()), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", Paginated$1_$reflection(Dta_DtaListItem_$reflection())]], [["ErrorValue", class_type("System.Exception")]]])]], [["Item", list_type(class_type("Browser.Types.File", undefined))]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [UploadResult_$reflection(), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", UploadResult_$reflection()]], [["ErrorValue", class_type("System.Exception")]]])]], [["Item", UploadResult_$reflection()]], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [class_type("System.Guid"), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", class_type("System.Guid")]], [["ErrorValue", class_type("System.Exception")]]])]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [class_type("Fetch.Types.Response"), class_type("System.Exception")], FSharpResult$2, () => [[["ResultValue", class_type("Fetch.Types.Response")]], [["ErrorValue", class_type("System.Exception")]]])]], [["Item", GlobalMsg_$reflection()]]]);
}

export class Model extends Record {
    constructor(PageNumber, DtaList, UploadCount, Sending, UploadList) {
        super();
        this.PageNumber = PageNumber;
        this.DtaList = DtaList;
        this.UploadCount = (UploadCount | 0);
        this.Sending = Sending;
        this.UploadList = UploadList;
    }
}

export function Model_$reflection() {
    return record_type("Dta.Types.Model", [], Model, () => [["PageNumber", option_type(int32_type)], ["DtaList", Remote$1_$reflection(Paginated$1_$reflection(Dta_DtaListItem_$reflection()))], ["UploadCount", int32_type], ["Sending", bool_type], ["UploadList", list_type(UploadResult_$reflection())]]);
}

export function Model__IsSending(x) {
    if (x.Sending) {
        return true;
    }
    else {
        return x.UploadCount > 0;
    }
}

export function Model__CanConfirm(x) {
    if (!x.Sending) {
        return !isEmpty(x.UploadList);
    }
    else {
        return false;
    }
}

//# sourceMappingURL=Types.fs.js.map
